export const FILTER_SESSION_KEY = "showroom_filters";

export const emptyFilters = {
    selectedColors: [],
    selectedProductTypes: [],
    selectedTypes: [],
    cannabinoid_level_min: null,
    cannabinoid_level_max: null,
    terpene_level_min: null,
    terpene_level_max: null,
    price_min: null,
    price_max: null,
    filteredCannabinoids: [],
    filteredTerpenes: [],
    minTotalCannabinoids: null,
    maxTotalCannabinoids: null,
    minTotalTerpenes: null,
    maxTotalTerpenes: null,
    filterByProductName: null,
    filteredIndustries: [],
};
